<template>
  <div class="form-check text-white">
    <input
      class="form-check-input"
      type="checkbox"
      v-model="checked"
      id="defaultCheck1"
    />
    <label class="form-check-label" for="defaultCheck1">
      {{ t("Discount", {}, { locale: $store.getters.getLang }) }}</label
    >
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
export default {
  name: "CheckboxSingle",
  props: {
    modelValue: Boolean,
  },
  setup(props, { emit }) {
    let checked = ref(props.modelValue);
    const { t, locale } = useI18n();
    watch(
      () => checked.value,
      (value) => {
        emit("update:modelValue", value);
      }
    );

    return { t, locale, checked };
  },
};
</script>

<style scoped>
.form-check {
  margin-top: 19px;
}
.form-check-input {
  width: 1.6em;
  height: 1.6em;
  margin-right: 3px;
}
label {
  vertical-align: sub;
}
</style>
